import React from "react";
import styled from "styled-components";
import SummaryProductTile from "../../components/SummaryProductTile.tsx";
import { useDispatch, useSelector } from "react-redux";
import { translations } from "../../../utils/translations.js";
import EmptyCard from "../../components/EmptyCard.tsx";
import CheckoutSummary from "../../components/CheckoutSummary.tsx";
import SuccesfulOrderPlacementComponent from "../../components/SuccesfulOrderPlacementComponent.tsx";
import { dataActions } from "../../../store/index.js";
import { calculateDiscountedPrice } from "../../../utils/utils.ts";
import { useNavigate } from "react-router-dom";
import { orderTaxesNames } from "../../../utils/constants.ts";
import {
  createCardPayment,
  updateOrderPaymentStatus,
} from "../../../services/orderService.js";
import { useAuth } from "../../../hooks/useAuth.jsx";
import Loader from "../../components/core-components/Loader.tsx";

const Wrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
`;

const PageTitle = styled.h2`
  margin-left: 2rem;
  color: var(--secondary-font-color);
  font-family: Georgia, serif;
  letter-spacing: 1px;
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 1rem;

  @media (max-width: 850px) {
    flex-direction: column;
    gap: 8px;
    height: 100%;
  }
`;
const ProductsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
`;
const SummaryWrapper = styled.div`
  flex: 1;

  @media (max-width: 850px) {
    width: 100%;
  }
`;
const Cart = () => {
  const languageCode = useSelector((state) => state.settings.languageCode);
  const products = useSelector((state) => state.data.cartProducts);
  const [placedOrder, setPlacedOrder] = React.useState(false);
  const dispach = useDispatch();
  const navigate = useNavigate();
  const { token } = useAuth();

  const handlePlaceOrder = async (order) => {
    setPlacedOrder(true);
    dispach(dataActions.clearCart());

    if (order?.paymentOption === orderTaxesNames.card) {
      const paymentData = {
        orderNumber: order.orderID,
        amount: Number(order.totalPrice).toFixed(2) * 100,
        orderBundle: {
          customerDetails: {
            email: order.email,
            phone: order.phoneNumber,
            deliveryInfo: {
              city: order.city,
              postAddress: order.street,
            },
          },
        },
      };
      try {
        const response = await createCardPayment(paymentData, token);
        if (response?.formUrl && response?.orderId) {
          window.location.href = response.formUrl;
        } else {
          navigate("/placed-order/failed", { replace: true });
        }
      } catch (error) {
        console.error("Error at payment", error);
      }
    } else {
      navigate("/placed-order/succes", { replace: true });
    }
  };

  if (products.length === 0 && !placedOrder) {
    return (
      <Wrapper>
        <EmptyCard />
      </Wrapper>
    );
  }
  if (products.length === 0 && placedOrder) {
    return (
      <Wrapper>
        <Loader />;
      </Wrapper>
    );
  }
  const totalPrice = products
    .reduce(
      (sum, product) =>
        sum +
        calculateDiscountedPrice(product.price, product.discount) *
          product.quantity,
      0
    )
    .toFixed(2);

  const itemsNumber = products.reduce(
    (sum, product) => sum + product.quantity,
    0
  );

  return (
    <Wrapper>
      <PageTitle>{translations[languageCode]["checkout-title"]}</PageTitle>
      <Content>
        <ProductsWrapper>
          {products.map((product) => (
            <SummaryProductTile
              key={product.id}
              productID={product.id}
              productName={product.name}
              quantity={product.quantity}
              price={product.price}
              discount={product.discount}
              image={product.image}
            />
          ))}
        </ProductsWrapper>
        <SummaryWrapper>
          <CheckoutSummary
            totalPrice={totalPrice}
            itemsNumber={itemsNumber}
            products={products}
            placeOrderSuccess={handlePlaceOrder}
          />
        </SummaryWrapper>
      </Content>
    </Wrapper>
  );
};

export default Cart;
